import { render } from "./WalletConnectorList.vue?vue&type=template&id=3f3d24be&scoped=true"
import script from "./WalletConnectorList.vue?vue&type=script&lang=js"
export * from "./WalletConnectorList.vue?vue&type=script&lang=js"

import "./WalletConnectorList.vue?vue&type=style&index=0&id=3f3d24be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f3d24be"

export default script